export default __webpack_public_path__ + "static/media/rosebyteslogo-trans.67f2d660.png";